import { REST_BASE } from '../api/applicationTemplates';
import { writeStoredUser } from './oidcStorage';

/**
 * Kun i dev: `?devlogin=12976` logger inn som søkeren med portal_user.id 12976
 * uten BankID. Lar Claude Code teste søkerportalen i nettleseren.
 *
 * API-et identifiserer søkere på BankID-`sub` alene. Vi henter derfor sub-en
 * fra `POST /rest/devlogin/applicant/{id}` i lyfti-api og legger en OIDC-
 * bruker under nøkkelen oidc-client-ts selv bruker (helpers/oidcStorage.ts). Da
 * plukker både `useAuth()` og `readOidcSub()` den opp uten egne dev-grener.
 *
 * Endepunktet svarer 404 med mindre lokal lyfti-api har LYFTI_DEV_LOGIN=1.
 * Må kjøres før `<OidcAuthProvider>` mounter, altså før render i main.tsx.
 */
export async function captureDevLoginFromUrl(): Promise<boolean> {
    if (!import.meta.env.DEV) return false;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('devlogin')) return false;
    const userId = Number(params.get('devlogin'));

    params.delete('devlogin');
    const newQuery = params.toString();
    window.history.replaceState(
        {},
        '',
        window.location.pathname + (newQuery ? `?${newQuery}` : '') + window.location.hash,
    );

    if (!(userId > 0)) {
        console.warn('[devlogin] bruk ?devlogin={portal_user.id}');
        return false;
    }

    try {
        const res = await fetch(`${REST_BASE}/devlogin/applicant/${userId}`, { method: 'POST' });
        const body = await res.json().catch(() => null);
        const sub = body?.data?.sub;
        if (!res.ok || !sub) {
            console.warn('[devlogin] avvist', res.status, body?.message);
            return false;
        }

        // Overskriver en eventuell ekte BankID-økt — samme nøkkel
        writeStoredUser({
            access_token: 'devlogin',
            token_type: 'Bearer',
            scope: 'openid profile nin email',
            profile: { sub },
            // Langt fram i tid, så oidc-client-ts aldri prøver å fornye tokenet.
            expires_at: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 7,
        });
        return true;
    } catch (err) {
        console.warn('[devlogin] feilet', err);
        return false;
    }
}
